import React from 'react'


const Manual = ({ lab, isMobile }) => {
	if (!lab || !lab.pathname) { return null; }

	let file = null;

	switch (lab.pathname) {
		case 'bon-growthstrategy':
			file = '陳喬泓翻倍成長選股策略使用介紹篇';

			break;

		case 'camper-htstrategy':
			file = '股海老牛使用教學';

			break;

		case 'modifiedvalue':
			file = '修正式價值投資策略操作手冊';

			break;

		case 'stocksardine-strategy':
			file = '股魚價值K線使用手冊';

			break;

		default:

	}

	return (file
		?
		<a
			className="manual-link"
			href={`${process.env.REACT_APP_DOMAIN}/assets/documents/${file}.pdf`}
			target="_blank"
			rel="nofollow noopener noreferrer"
		>
			<div className="manual-link-txt">
				{isMobile ? <i className="far fa-file-pdf"/> : '使用手冊'}
			</div>
		</a>
		:
		file
	);
}


export { Manual }
